// @ts-nocheck
/* eslint-disable */
export const chevronLeftIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960" fill="currentColor"><path d="M560-240 320-480l240-240 56 56-184 184 184 184-56 56Z"/></svg>`,
    name: 'chevron-left' as const
};